import { boxProgramColors, type BoxProgramColorType } from "@/modules/boxProgrammation/components/boxProgramColors"
import { cn } from "@/modules/lib/utils"
import styled from "styled-components"

function isColorKey(key: string): key is BoxProgramColorType {
  return Object.prototype.hasOwnProperty.call(boxProgramColors, key)
}

export function BoxProgramColorSelection({
  selectedColor,
  onChangeSelectedColor,
  striped = false,
  className,
  ...props
}: {
  selectedColor: BoxProgramColorType
  onChangeSelectedColor: (arg0: BoxProgramColorType) => void
  striped?: boolean
} & React.ComponentProps<"div">) {
  return (
    <div className={cn("flex justify-around px-4", className)} {...props}>
      {Object.entries(boxProgramColors).map(([key, value]) => {
        if (!isColorKey(key)) return null
        return (
          <ColorContainer
            key={key}
            $isSelected={key === selectedColor}
            onClick={() => {
              onChangeSelectedColor(key)
            }}
          >
            <ColorCircle $color={value.background} $striped={striped} />
          </ColorContainer>
        )
      })}
    </div>
  )
}

export const ColorCircle = styled.div<{ $color: string; $striped?: boolean }>`
  background: ${({ $color, $striped }) =>
    $striped
      ? `linear-gradient(180deg, ${$color} 0%, ${$color} 10%, white 10%, white 30%, ${$color} 30%, ${$color} 50%, white 50%, white 70%, ${$color} 70%, ${$color} 90%, white 90%, white 100%)`
      : $color};
  width: 30px;
  height: 30px;
  border-radius: 15px;
  border: ${({ $striped }) => ($striped ? "1px solid var(--interactive-border-neutral-default)" : "none")};
  cursor: pointer;
`

const ColorContainer = styled.div<{ $isSelected: boolean }>`
  width: 38px;
  height: 38px;
  border-radius: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${({ $isSelected }) =>
    $isSelected ? "2px solid var(--interactive-border-primary-default)" : "1px solid transparent"};
  transition: border 0.2s ease;
  &:hover {
    border: 1px solid var(--interactive-border-neutral-default);
  }
`
